<div [showLoadingSpinner]="loadingService.isLoading(this)">
    <img
        class="image"
        *ngIf="image.status === imageStatus.FULFILLED; else empty"
        [src]="image.source"
        alt="image"
    />

    <ng-template #empty>
        <div class="empty">
            <span *ngIf="image.status === imageStatus.EMPTY">No image</span>
        </div>
    </ng-template>

    <button
        type="button"
        mat-mini-fab
        aria-label="Change image"
        class="edit-button"
        color="primary"
        (click)="openDialog(imageInput)"
    >
        <mat-icon>edit</mat-icon>
    </button>

    <input #imageInput hidden type="file" accept="image/*" (change)="processFile(imageInput)" />
</div>
